/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { SVGIcon, Text, Tooltip } from "@nordcloud/gnui";
import { dateFormat } from "~/constants";
import { RouteParams, Environment } from "~/models";
import { ROUTES } from "~/routing";
import { StyledLinkSmall } from "../Styled/Common";
import FlexContainer from "../Styled/FlexContainer";

type EnvStatusARInfoProps = {
  environmentStatus: Environment["environmentStatus"];
};

const Wrap = styled.div`
  margin-left: 1rem;
  margin-top: 0.4rem;
`;

function EnvStatusARInfo({ environmentStatus }: EnvStatusARInfoProps) {
  const state = useParams<RouteParams>();
  const { customerId } = state;

  return (
    <Wrap>
      <Tooltip
        status="notification"
        position="left"
        caption={
          <FlexContainer aria-label="notification" direction="column">
            <Text m="0" mr="0.3rem" size="sm">
              Applied by:
            </Text>

            <StyledLinkSmall
              to={`${ROUTES.customers.index}/${customerId}/assignment-rules/${environmentStatus?.assignmentRule?.id}`}
            >
              {environmentStatus?.assignmentRule?.name}
            </StyledLinkSmall>
            <Text size="sm" m="0" weight="medium">
              {dayjs(environmentStatus?.log?.modified?.time).format(dateFormat)}
            </Text>
          </FlexContainer>
        }
      >
        <FlexContainer css={{ marginRight: "1rem" }}>
          <SVGIcon size="sm" name="info" aria-label="info" />
        </FlexContainer>
      </Tooltip>
    </Wrap>
  );
}

export { EnvStatusARInfo };
